import axios from "axios";

/**
 * Fetch data from the API and update state in the parent component.
 *
 * @param {string} pageName - The API endpoint page name (e.g., "juniorTeen").
 * @param {Function} setData - State setter function to update the data.
 * @param {Function} setLoading - State setter function to update the loading state.
 *
 * @example
 * fetchData("juniorTeen", setData, setLoading);
 */
export async function fetchData(pageName, setData, setLoading) {
    const API_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/"
        : "https://api.hillerodfrimenighed.dk/";

    setLoading(true);
    try {
        
        const response = await axios.get(`${API_URL}page/${encodeURIComponent(pageName)}`);
        setData(response.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        setData(null);
    } finally {
        setLoading(false);
    }
}